import { createContext, useContext } from 'react';

type MobileNavContextValue = {
  open: () => void;
  close: () => void;
};

const MobileNavContext = createContext<MobileNavContextValue | null>(null);

export function MobileNavProvider({
  value,
  children,
}: {
  value: MobileNavContextValue;
  children: React.ReactNode;
}) {
  return <MobileNavContext.Provider value={value}>{children}</MobileNavContext.Provider>;
}

export function useMobileNav() {
  return useContext(MobileNavContext);
}
